import { createSlice } from '@reduxjs/toolkit'

import * as reducers from './reducers'

import { initialState } from './data'

const errorSlice = createSlice({
  name: 'errors',
  initialState,
  reducers
})

export default errorSlice
